import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0002',
    ecrans: ['00-2'],
    params: [
        'id',
        '?eplcleint',
        '?demcleint',
        '?lemcleint',
        '?tytcleint'
    ]
});
